// 開発は5min, 本番では5hを録音時間の最大とする。[ms]
export const MAX_TOTAL_RECORDING_TIME =
  import.meta.env.MODE == "development" ? 5 * 60 * 1000 : 5 * 60 * 60 * 1000;

export const MAX_INTERVAL_RECORDING_TIME =
  import.meta.env.MODE == "development" ? 5000 : 12000; // milli second

export const INTERVAL_TIME = 10;
